import { FC, useCallback, useState } from 'react';
import { Button, Typography, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAuthDispatchContext, useAuthStateContext } from 'providers/Auth';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import VerificationInput from 'react-verification-input';
import { useAppDispatch } from 'store/hooks';
import { setIsLoggedIn } from 'store/user/slice';

import { Content, LinkWrapper } from '../ForgetPassword/styled';
import { InputContainer } from './styled';
import { refreshTokenStorage, tokenStorage } from 'utils/storage';

const { Title } = Typography;

const Auth2FA: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [value, setValue] = useState('');
  const [isLoading, setLoading] = useState(false);

  const { tmpToken } = useAuthStateContext();
  const { verify2FA } = useAuthDispatchContext();

  const onFinish = useCallback(
    async (code?: string) => {
      setLoading(true);
      await verify2FA(code || value, tmpToken)
        .then(res => {
          if (res.data) {
            const data = res.data;

            if (data.accessToken) {
              tokenStorage.set(data.accessToken);
            }

            if (data.refreshToken) {
              refreshTokenStorage.set(data.refreshToken);
            }

            dispatch(setIsLoggedIn(true));
          }
        })
        .catch(err => {
          setLoading(false);
          message.error(err.message);
        });
    },
    [verify2FA, dispatch, value, tmpToken]
  );

  return (
    <Content>
      <Title level={2} style={{ marginBottom: 24 }}>
        {t('2fa.title')}
      </Title>
      <InputContainer>
        <VerificationInput
          classNames={{
            container: 'container',
            character: 'character',
            characterInactive: 'character--inactive',
            characterSelected: 'character--selected'
          }}
          placeholder=""
          autoFocus
          onComplete={onFinish}
          validChars="0-9"
          onChange={code => setValue(code)}
          value={value}
        />
      </InputContainer>
      <Button
        type="primary"
        onClick={() => onFinish()}
        shape="round"
        loading={isLoading}
        disabled={value.length !== 6}
        block
      >
        {t('common.submit')}
      </Button>
      <LinkWrapper>
        <Link to="/login" style={{ fontSize: 12, color: 'var(--text-color)' }}>
          <ArrowLeftOutlined style={{ marginRight: 12 }} />
          {t('auth.back_login')}
        </Link>
      </LinkWrapper>
    </Content>
  );
};

export default Auth2FA;
